export { InformationModal } from './InformationModal';
